import { call, put, takeEvery, takeLatest, select } from "redux-saga/effects";
import { toast } from "react-toastify";
import { push } from "redux-router";
import validator from "services/validator.js";
import constants from "constants";
import actions from "actions";
import axios from "axios";
import { addConfirmationUsers } from "actions/users";
import { clearAdminCertificatesUsers } from "../../actions/users";

const {
  addAdminUsers,
  addRequestError,
  cleanErrors,
  addErrorsSaga,
  addValidateError,
  setEditUser,
  addAdminAdminDashboardUsers,
  addAssignedUsers,
  addNovonordiskUsers,
  setAdminCertificatesUsers,
} = actions;

const {
  LOAD_ADMIN_USERS_SAGA,
  ADMIN_CREATE_USER_SAGA,
  ADMIN_CREATE_USER_SPONSOR_SAGA,
  API_ADMIN_USERS,
  API_ADMIN_USERS_SPONSORS,
  ADMIN_POST_ASSIGNED_USERS_SAGA,
  ADMIN_DELETE_USERS_SAGA,
  LOAD_EDIT_USER_SAGA,
  ADMIN_UPDATE_USER_SAGA,
  USER_FILTER_SAGA,
  USER_SPONSOR_FILTER_SAGA,
  LOAD_ADMIN_DASHBOARD_USERS_SAGA,
  API_DASHBOARDS,
  LOAD_NOVONORDISK_SUBSCRIBED_USERS_SAGA,
  API_NOVONORDISK_SUBSCRIBE_USERS,
  ADMIN_GET_CERTIFICATES_USERS,
  API_CERTIFICATES_USERS,
  ADMIN_CREATE_CERTIFICATES_USERS,
  API_ADMIN_CERTIFICATES,
  REGISTER_REQUEST_TO_ADMIN,
  API_REGISTER_REQUEST_TO_ADMIN,
} = constants;

const apiLoadAdminUsers = (page, query, per_page) => {
  return axios.get(API_ADMIN_USERS, {
    params: {
      page: page,
      per_page: 50,
      ...query,
    },
  });
};

const apiLoadConfirmationUsers = (page, query, per_page) => {
  return axios.get(API_CONFIRMATION_USERS, {
    params: {
      page: page,
      per_page: 50,
      ...query,
    },
  });
};

const apiLoadAdminUsersSponsors = (page, query) => {
  return axios.get(API_ADMIN_USERS_SPONSORS, {
    params: {
      page: page,
      per_page: 5,
      ...query,
    },
  });
};

const apiRegisterRequestToAdmin = (data) => {
  return axios.post(API_REGISTER_REQUEST_TO_ADMIN, data);
};

const apiCreateUser = (user) => {
  return axios.post(API_ADMIN_USERS, {
    user: user,
  });
};
const apiPostAssignedUsers = (
  assigned_users,
  only_assigned,
  page,
  query,
  per_page
) => {
  const onlyAssigned = only_assigned ? { only_assigned } : {};

  const pagination = page && per_page ? { page, per_page } : {};

  return axios.put(
    `/api/v1/admin/assigned_users`,
    {
      assigned_ids: assigned_users,
    },
    {
      params: {
        ...pagination,
        ...onlyAssigned,
        ...query,
      },
    }
  );
};

const apiCreateUserSponsor = (user) => {
  let data = new FormData();

  for (let i in user) {
    if (user[i] !== null) data.append(`user[${i}]`, user[i]);
  }

  return axios.post(API_ADMIN_USERS, data);
};

const apiDeleteUsers = (user_ids) => {
  return axios.post(API_ADMIN_USERS + "/destroy", {
    user_ids: user_ids,
  });
};

const apiGetUser = (user_id) => {
  return axios.get(`${API_ADMIN_USERS}/${user_id}`);
};

const apiAdminUpdateUser = (user) => {
  let data = new FormData();

  for (let i in user) {
    if (user[i] !== null) data.append(`user[${i}]`, user[i]);
  }

  return axios.put(`${API_ADMIN_USERS}/${user.id}`, data);
};

const apiloadNovonordiskSubscribedUsersSaga = (page, query) =>
  axios.get(API_NOVONORDISK_SUBSCRIBE_USERS, {
    params: {
      page,
      per_page: 50,
      ...query,
    },
  });
const apiLoadAdminDashboardUsers = (query) =>
  axios.get(API_DASHBOARDS, {
    params: {
      ...query,
      page: 0,
    },
  });

const apiGetAdminCertificatesUsers = (params) =>
  axios.get(API_CERTIFICATES_USERS, {
    params,
  });

const apiCreateAdminCertificatesUsers = (body) =>
  axios.post(API_ADMIN_CERTIFICATES, body);

function* loadAdminUsers({ page = 1, query = {}, per_page = 5 }) {
  try {
    const response = yield call(apiLoadAdminUsers, page, query, per_page);
    const users = response.data.users;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addAdminUsers(users, count, page, totalPages, query));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* confirmationUsersFilter({ page = 1, query = {}, per_page = 5 }) {
  try {
    const response = yield call(
      apiLoadConfirmationUsers,
      page,
      query,
      per_page
    );
    const users = response.data.confirmation_users;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addConfirmationUsers(users, count, page, totalPages, query));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadAdminUsersSponsors({ page = 1, query = {} }) {
  try {
    const response = yield call(apiLoadAdminUsersSponsors, page, query);
    const users = response.data.sponsors;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addAdminUsers(users, count, page, totalPages, query));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* registerRequestToAdmin({ payload }) {
  try {
    yield call(apiRegisterRequestToAdmin, payload);
    toast.success("Request has been sent");

    yield put(push("/register-request-confirm"));
  } catch (e) {
    toast.warn(e.response.data.error_message);
    yield put(addErrorsSaga(REGISTER_REQUEST_TO_ADMIN, e.response));
  }
}

function* createUser({ user, redirect }) {
  const userData = user;
  try {
    const errors = validator.validate(userData, "adminCreateUserSponsor");
    if (errors) {
      yield put(addValidateError(ADMIN_CREATE_USER_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(ADMIN_CREATE_USER_SAGA));
    }

    const response = yield call(apiCreateUser, userData);
    const user = response.data.user;
    const role = yield select((state) => state.users.user.role);

    toast.success("User successfully created!");

    if (role === "host") {
      yield put(push("/"));
    }

    yield put(push(redirect ? redirect : "/users/"));
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_CREATE_USER_SAGA, e.response));
  }
}

function* postAssignedUsers({
  assigned_users,
  only_assigned,
  page,
  query = {},
  per_page,
}) {
  const users = assigned_users;
  try {
    const response = yield call(
      apiPostAssignedUsers,
      users,
      only_assigned,
      page,
      query,
      per_page
    );
    const assignedUsers = response.data.users;
    const count = response.data.count;
    const totalPages = response.data.total_pages;

    yield put(addAssignedUsers(assignedUsers, count, page, totalPages, query));
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_POST_ASSIGNED_USERS_SAGA, e.response));
  }
}

function* createUserSponsor({ user }) {
  const userData = user;
  try {
    const errors = validator.validate(userData, "adminCreateUserSponsor");
    if (errors) {
      yield put(addValidateError(ADMIN_CREATE_USER_SPONSOR_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(ADMIN_CREATE_USER_SPONSOR_SAGA));
    }

    const response = yield call(apiCreateUserSponsor, userData);
    const user = response.data.user;
    toast.success("Users Sponsors successfully created!");
    yield put(push("/users_sponsors/"));
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_CREATE_USER_SPONSOR_SAGA, e.response));
  }
}

function* deleteUsers({ user_ids }) {
  const userIds = user_ids;
  try {
    yield call(apiDeleteUsers, userIds);
    toast.success("Users successfully deleted!");
    const query = yield select((state) => state.users.adminUsers.query) || {};
    const page = yield select((state) => state.users.adminUsers.page) || 1;
    yield call(loadAdminUsers, { page, query });
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_CREATE_USER_SAGA, e.response));
  }
}

function* loadEditUser({ user_id }) {
  try {
    const response = yield call(apiGetUser, user_id);
    const user = response.data.user;
    yield put(setEditUser(user));
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_CREATE_USER_SAGA, e.response));
  }
}

function* adminUpdateUser({ user }) {
  const userData = user;
  try {
    const errors = validator.validate(userData, "userProfile");
    if (errors) {
      yield put(addValidateError(ADMIN_UPDATE_USER_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(ADMIN_UPDATE_USER_SAGA));
    }

    const response = yield call(apiAdminUpdateUser, userData);
    toast.success("Users successfully updated!");
    if (response.data.user.user_type != "sponsor") {
      yield put(push("/users/"));
    } else {
      yield put(push("/users_sponsors/"));
    }
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_UPDATE_USER_SAGA, e.response));
  }
}

// function* adminUpdateUserSponsor({ user }) {
//   const userData = user;
//   try {
//     const errors = validator.validate(userData, 'userProfile');
//     if (errors) {
//       yield put(addValidateError(ADMIN_UPDATE_USER_SAGA, errors));
//       return;
//     } else {
//       yield put(cleanErrors(ADMIN_UPDATE_USER_SAGA))
//     }

//     const response = yield call(apiAdminUpdateUser, userData);
//     toast.success('Users Sponsors successfully updated!');
//     yield put(push('/users_sponsors/'))
//   } catch (e) {
//     console.log(e);
//     yield put(addErrorsSaga(ADMIN_UPDATE_USER_SAGA, e.response))
//   }
// }

function* loadAdminAdminDashboardUsers({ query }) {
  try {
    const response = yield call(apiLoadAdminDashboardUsers, query);
    const statistics = response.data.result;
    yield put(addAdminAdminDashboardUsers(statistics));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* getAdminCertificatesUsers({ payload }) {
  try {
    const response = yield call(apiGetAdminCertificatesUsers, payload);
    yield put(setAdminCertificatesUsers(response.data));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* createAdminCertificatesUsers({ payload }) {
  try {
    const { groupId, ...body } = payload;
    yield call(apiCreateAdminCertificatesUsers, body);
    toast.success("Certificates successfully added");
    yield put(clearAdminCertificatesUsers());
    if (groupId) {
      yield put(push(`/groups/${groupId}/webinars`));
    } else {
      yield put(push("/webinars"));
    }
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadNovonordiskSubscribedUsersSaga({ page = 1, query = {} }) {
  try {
    const response = yield call(
      apiloadNovonordiskSubscribedUsersSaga,
      page,
      query
    );
    const result = response.data.users;
    yield put(addNovonordiskUsers(result));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}
function* adminFilterUser({ page = 1, query = {}, per_page = 5 }) {
  yield call(loadAdminUsers, { page, query, per_page });
}

function* adminFilterUserSponsor({ page = 1, query = {} }) {
  yield call(loadAdminUsersSponsors, { page, query });
}

function* __loadAdminUsers() {
  yield takeEvery(LOAD_ADMIN_USERS_SAGA, loadAdminUsers);
}
function* __loadNovonordiskSubscribedUsersSaga() {
  yield takeEvery(
    LOAD_NOVONORDISK_SUBSCRIBED_USERS_SAGA,
    loadNovonordiskSubscribedUsersSaga
  );
}

function* __registerRequestToAdmin() {
  yield takeLatest(REGISTER_REQUEST_TO_ADMIN, registerRequestToAdmin);
}

function* __adminCreateUserSaga() {
  yield takeLatest(ADMIN_CREATE_USER_SAGA, createUser);
}

function* __adminPostAssignedUsersSaga() {
  yield takeLatest(ADMIN_POST_ASSIGNED_USERS_SAGA, postAssignedUsers);
}

function* __adminCreateUserSponsorSaga() {
  yield takeLatest(ADMIN_CREATE_USER_SPONSOR_SAGA, createUserSponsor);
}

function* __adminDeleteUsersSaga() {
  yield takeLatest(ADMIN_DELETE_USERS_SAGA, deleteUsers);
}

function* __loadEditUserSaga() {
  yield takeLatest(LOAD_EDIT_USER_SAGA, loadEditUser);
}

function* __adminUpdateUserSaga() {
  yield takeLatest(ADMIN_UPDATE_USER_SAGA, adminUpdateUser);
}

// function* __adminUpdateUserSponsorSaga() {
//   yield takeLatest(ADMIN_UPDATE_USER_SAGA, adminUpdateUserSponsor)
// }

function* __adminUserFilterSaga() {
  yield takeLatest(USER_FILTER_SAGA, adminFilterUser);
}

// function* __approveDisciplineSaga() {
//   yield takeLatest(APPROVE_DISCIPLINE_FILTER_SAGA, confirmationUsersFilter)
// }

function* __adminUserSponsorFilterSaga() {
  yield takeLatest(USER_SPONSOR_FILTER_SAGA, adminFilterUserSponsor);
}

function* __loadAdminAdminDashboardUsersSaga() {
  yield takeLatest(
    LOAD_ADMIN_DASHBOARD_USERS_SAGA,
    loadAdminAdminDashboardUsers
  );
}

function* __getAdminCertificatesUsers() {
  yield takeLatest(ADMIN_GET_CERTIFICATES_USERS, getAdminCertificatesUsers);
}

function* __createAdminCertificatesUsers() {
  yield takeLatest(
    ADMIN_CREATE_CERTIFICATES_USERS,
    createAdminCertificatesUsers
  );
}

export {
  __adminCreateUserSaga,
  __adminCreateUserSponsorSaga,
  __loadAdminUsers,
  __adminDeleteUsersSaga,
  __loadEditUserSaga,
  __adminUpdateUserSaga,
  //__adminUpdateUserSponsorSaga,
  __adminUserFilterSaga,
  __adminUserSponsorFilterSaga,
  __loadAdminAdminDashboardUsersSaga,
  __adminPostAssignedUsersSaga,
  __loadNovonordiskSubscribedUsersSaga,
  __getAdminCertificatesUsers,
  __createAdminCertificatesUsers,
  __registerRequestToAdmin,
  // __approveDisciplineSaga
};



// WEBPACK FOOTER //
// ./src/sagas/admin/users.js